export default __webpack_public_path__ + "static/media/AlphaPharmacy.c3250da7.png";